module.exports = __webpack_public_path__ + "img/welcome_exhexp.f6ab25f7.jpg";